import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { useSelector } from "react-redux";
import { format } from "date-fns";

const defaultTake = 10;

export const useAPIGetCustomerVoucher = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();
  const employee = useSelector((state) => state.auth.employee);

  const [filterValue, setFilterValue] = useState({
    customer_id: null,
    data_customer: null,
    product_id: null,
    data_product: null,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });
  const [listData, setListData] = useState([]);
  const [listDataPending, setListDataPending] = useState([]);
  const [listDataExpired, setListDataExpired] = useState([]);

  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingPending, setLoadingPending] = useState(false);
  const [loadingExpired, setLoadingExpired] = useState(false);

  //  API call section

  const fetchListData = async ({ page, take, filter }) => {
    let newFilter = filter ?? getFilter(filterValue);
    const today = format(new Date(), "yyyy-MM-dd");

    if (employee?.user_type == 3) {
      newFilter = `data_customer.bc_id:=:${employee?.id};${newFilter}`;
    }

    const bc = employee?.user_type == 3;
    const finance = employee?.user_type == 11;
    const filterFinance = finance ? `verif_bc_id:!=:Null;verif_owner_id:=:Null` : "";
    const filterBC = bc ? `verif_bc_id:=:Null` : "";

    // 🔹 MAIN DATA
    setLoadingMain(true);
    requestGet({
      fullUrl: `/api/customer/customervoucher/data`,
      params: {
        page,
        take,
        filter: `${newFilter};verif_owner_id:!=:Null`,
        order: "expired_date",
        order_method: "ASC",
        "with_customer,data_bc": 1,
        "with_sales_payment,data_sales": 1,
        with_created_by: 1,
        with_verif_bc: 1,
        with_verif_owner: 1,
      },
      onSuccess: ({ pagination, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter,
        });

        setListData(data.map((el, i) => ({
          ...el,
          no: (page - 1) * take + i + 1,
        })));
        setLoadingMain(false);
      },
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
        setLoadingMain(false);
      },
    });

    // 🔹 PENDING DATA
    setLoadingPending(true);
    requestGet({
      fullUrl: `/api/customer/customervoucher/data`,
      params: {
        page: 1,
        take: 10000,
        filter: `${newFilter};expired_date:>=:${today};${filterFinance || filterBC || "verif_bc_id:=:Null||verif_owner_id:=:Null"}`,
        order: "expired_date",
        order_method: "ASC",
        "with_customer,data_bc": 1,
        "with_sales_payment,data_sales": 1,
        with_created_by: 1,
        with_verif_bc: 1,
        with_verif_owner: 1,
      },
      onSuccess: ({ data }) => {
        setListDataPending(
          data.filter(el => el.verif_owner_id == null).map((el, i) => ({
            ...el,
            no: i + 1,
          }))
        );
        setLoadingPending(false);
      },
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
        setLoadingPending(false);
      },
    });

    // 🔹 EXPIRED DATA
    setLoadingExpired(true);
    requestGet({
      fullUrl: `/api/customer/customervoucher/data`,
      params: {
        page,
        take,
        filter: `${newFilter};sales_payment_id:=:Null;expired_date:<=:${today}`,
        order: "expired_date",
        order_method: "ASC",
        "with_customer,data_bc": 1,
        "with_sales_payment,data_sales": 1,
        with_created_by: 1,
        with_verif_bc: 1,
        with_verif_owner: 1,
      },
      onSuccess: ({ data }) => {
        setListDataExpired(data.map((el, i) => ({
          ...el,
          no: (page - 1) * take + i + 1,
        })));
        setLoadingExpired(false);
      },
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
        setLoadingExpired(false);
      },
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.customer_id) {
      filterArr.push(`customer_id:=:${newFilterValue.customer_id}`);
    }

    if (newFilterValue.name) {
      filterArr.push(`name:=:${newFilterValue.name}`);
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: defaultTake });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnUpdateViewRow = (row) => {
    fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
    // let foundInList = false;
    // let newListData = listData.map((el) => {
    //   if (el.id === row.id) {
    //     foundInList = true;
    //     return row;
    //   }
    //   return el;
    // });

    // if (!foundInList) {
    //   if (newListData.length > 0) {
    //     newListData.unshift(row);
    //   } else {
    //     newListData.push(row);
    //   }
    // }

    // // reorder no
    // newListData = newListData.map((el, index) => {
    //   return {
    //     ...el,
    //     no: (paging.page - 1) * paging.take + index + 1,
    //   };
    // });

    // setListDataPending(newListData);
  };

  const handleOnDeleteViewRow = (row) => {
    fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
    // let newListData = [...listData];

    // const index = newListData.findIndex((el) => el.id === row.id);
    // if (index > -1) {
    //   newListData.splice(index, 1);
    // }

    // // reorder no
    // newListData = newListData.map((el, index) => {
    //   return {
    //     ...el,
    //     no: (paging.page - 1) * paging.take + index + 1,
    //   };
    // });

    // setListDataPending(newListData);
  };

  const handleVerifBC = async (id, onSuccess) => {
    requestGet({
      fullUrl: `/api/customer/customervoucher/verify/${id}/bc`,
      onSuccess: ({ message, data }) => {
        uiContext.showSuccessMsg("Success", message);
        if (onSuccess) onSuccess(data);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const handleVerifOwner = async (id, onSuccess) => {
    requestGet({
      fullUrl: `/api/customer/customervoucher/verify/${id}/owner`,
      onSuccess: ({ message, data }) => {
        uiContext.showSuccessMsg("Success", message);
        if (onSuccess) onSuccess(data);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  return {
    loading,
    loadingMain,
    loadingPending,
    loadingExpired,
    listData,
    listDataPending,
    listDataExpired,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
    handleVerifBC,
    handleVerifOwner,
  };
};
